import { SlideLoveCover } from './SlideLoveCover'
import { SlideAttentionProblem } from './SlideAttentionProblem'
import { SlideWhatToSnakify } from './SlideWhatToSnakify'
import { SlideSnakToCampaign } from './SlideSnakToCampaign'
import { SlideChannelEntryPoints } from './SlideChannelEntryPoints'
import { SlideJascaydFocus } from './SlideJascaydFocus'
import { SlideJascaydJourney } from './SlideJascaydJourney'
import { SlideJascaydInvestment } from './SlideJascaydInvestment'

/** The Jascayd offer deck: the campaign offer first, then the Snakker story. */
export const slides = [
  SlideLoveCover,
  SlideJascaydFocus,
  SlideJascaydJourney,
  SlideJascaydInvestment,
  SlideAttentionProblem,
  SlideWhatToSnakify,
  SlideSnakToCampaign,
  SlideChannelEntryPoints,
]

export const slideTitles: { section: string; title: string }[] = [
  { section: '01', title: 'All You Need Is Love' },
  { section: '02 · Jascayd', title: 'Campaign Focus & Regional Scope' },
  { section: '03 · Jascayd', title: 'How the Campaign Runs' },
  { section: '04 · Jascayd', title: 'Indicative Investment' },
  { section: '05', title: 'HCPs Don’t Lack Content. They Lack Time.' },
  { section: '06', title: 'One Investment, Multiple Spinoff Use Cases' },
  { section: '07', title: 'How Each Campaign Drives the Knowledge for the Next' },
  { section: '08', title: 'One Experience. Many Entry Points.' },
]
